/* eslint-disable no-undef */
import "bootstrap/dist/css/bootstrap.min.css"
import "jquery-toast-plugin/dist/jquery.toast.min.css"

import "./assets/css/fonts/fontawesome/css/all.css"
import "react-perfect-scrollbar/dist/css/styles.css"
// import "../node_modules/font-awesome/css/font-awesome.min.css";
import "./assets/css/main.css"
import "jquery"
import "jquery-slimscroll"
import "jquery-toast-plugin"
import "bootstrap"
import "popper.js/dist/umd/popper.min.js"
import React from "react"
import { render } from "react-dom"
import { Provider } from "react-redux"
import loadable from "@loadable/component"

import store from "./redux/store"
import translate from "./translate/translate"

const MainLayout = loadable(() => import("./components/layout/main_layout"))

window.translate = translate
window.toast = (
   text = "Add content here !!!",
   type = "success",
   timeout = 3000,
   beforeShow = function() {},
   afterShown = function() {},
   beforeHide = function() {},
   afterHidden = function() {}
) => {
   $.toast({
      text: text,
      heading: "ADA",
      icon: type,
      showHideTransition: "fade",
      allowToastClose: true,
      hideAfter: timeout,
      stack: 7,
      position: "top-right",
      textAlign: "left",
      loader: true,
      loaderBg: "#9EC600",
      beforeShow: beforeShow,
      afterShown: afterShown,
      beforeHide: beforeHide,
      afterHidden: afterHidden
   })
}

render(
   <Provider store={store}>
      <MainLayout />
   </Provider>,
   document.getElementById("app")
)
